import initialState from 'redux/initial-states/loanRequests';
import pendingLoanRequests from './pendingLoanRequests';
import approveLoanRequest from './approveLoanRequest';
import amendLoanRequest from './amendLoanRequest';
import singleLoanRequest from './singleLoanRequest';
import microLoanNotifications from './microLoanNotifications';
import readMicroLoanNotification from './readMicroLoanNotification';
import readAllMicroLoanNotifications from './readAllMicroLoanNotifications';

export default (state = initialState, action = {}) => ({
  ...state,
  ...pendingLoanRequests(state, action),
  ...approveLoanRequest(state, action),
  ...amendLoanRequest(state, action),
  ...singleLoanRequest(state, action),
  ...microLoanNotifications(state, action),
  ...readMicroLoanNotification(state, action),
  ...readAllMicroLoanNotifications(state, action),
});
